'use client';

'use client';

import { UseFormReturn } from 'react-hook-form';

import {
  FileUploader,
  FileUploaderProps,
} from '@/components/file-upload/file-uploader';
import { UploadedFilesCard } from '@/components/file-upload/uploaded-files-card';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { useUploadFile } from '@/shared/hooks/use-upload-file';

interface Props extends FileUploaderProps {
  formReactHookForm: UseFormReturn<any>;
  name: string;
}
export const FormFileUpload = ({
  formReactHookForm,
  name,
  ...props
}: Props) => {
  const { progresses, uploadedFiles, isUploading } = useUploadFile(
    'imageUploader',
    { defaultUploadedFiles: [] },
  );

  return (
    <FormField
      control={formReactHookForm.control}
      name={name}
      render={({ field }) => {
        return (
          <div className="space-y-6 w-full">
            <FormItem className="w-full">
              {!props.isModal && <FormLabel>{props.label}</FormLabel>}
              <FormControl>
                <FileUploader
                  {...props}
                  value={field.value}
                  onValueChange={field.onChange}
                  progresses={progresses}
                  // pass the onUpload function here for direct upload
                  // onUpload={uploadFiles}
                  disabled={isUploading}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
            {uploadedFiles.length > 0 ? (
              <UploadedFilesCard uploadedFiles={uploadedFiles} />
            ) : null}
          </div>
        );
      }}
    />
  );
};
